<script setup lang="ts">
import { Utill } from '@/stores/Utill';
import { Data } from '@/stores/data';
import { HTTP } from '@/network/http';
import {
  ElMessageBox,
} from 'element-plus'

import {
  ref,
  watch,
  onMounted
} from 'vue'
const $emit = defineEmits(["upWjClickHandler"]);


onMounted(() => {

})
function clickWdwdBtn() {
  if (Utill.showLoginDialog()) {
    return;
  }
  // $emit('clickCard', text);
  Data.setCurrMode('noMode')
  if (fileInput.value) {
    fileInput.value.click(); // 触发文件选择对话框

  }
  // $emit('upWjClickHandler');

}
function clickLwBtn() {
  if (Utill.showLoginDialog()) {
    return;
  }
  if (Data.uploadDocumentsData.documentsData.length > 0) {
    ElMessageBox.confirm(
      '开启联网后，小鸿就不能基于文档回答了哦',
      '',
      {
        confirmButtonText: '开启联网',
        cancelButtonText: '取消',
        type: 'warning',
      }
    )
      .then(() => {
        Data.setCurrMode('lwss')
        Data.uploadDocumentsData.documentsData = [];
        Data.uploadDocumentsData.wjGroup = '';
      })
      .catch(() => {
      })
    return;
  }
  if (Data.currMode.value == 'lwss') {
    Data.setCurrMode('noMode')
  }
  else {
    Data.setCurrMode('lwss')
  }
}
const fileInput = ref<HTMLInputElement | null>(null);

const selectedFiles = ref<File[]>([]);
const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  console.log(">>>>upWjClickHandler>>>>", target)
  if (target.files && target.files.length > 0) {
    Utill.setDocumentsWjGroup();
    const file = target.files[0];

    // selectedFiles.value = Array.from(target.files); // 转换为数组

    // for (const file of selectedFiles.value) {
    let wjId = "wjId_" + Data.userInfo.value.openid + "_" + new Date().getTime();
    let wjGroup = Data.uploadDocumentsData.wjGroup;

    HTTP.uploadFiles(wjId, file, wjGroup, file.name)
    $emit('upWjClickHandler', wjId);
    console.log(">>>>upWjClickHandler>>>>", file)
    // getUploadData(wjId)
    // }

    console.log('上传的文件:', selectedFiles.value);
    // 这里可以添加进一步处理文件的逻辑，比如上传到服务器
  }
  target.value = '';
};



</script>

<template>
  <div class="down-cro">
    <div class="quickReplies my-information-btn">
      <el-tooltip class="box-item" effect="dark" :content="Data.currMode.value == 'lwss' ? '已开启' : '已关闭'"
        placement="top">
        <div class="quickItem" @click="clickLwBtn()">
          <img class="quick-icon" src="@/assets/lw-close.svg" v-show='Data.currMode.value != "lwss"' />
          <img class="quick-icon" src="@/assets/lw-open.svg" v-show='Data.currMode.value == "lwss"' />
          <span>联网搜索</span>
        </div>
      </el-tooltip>

      <div class="quickItem" @click="clickWdwdBtn()">
        <input type="file" ref="fileInput" @change="handleFileChange" accept=".pdf,.docx,.ppt,.txt,.jpg,.png"
          style="display: none;" />
        <!-- <button @click="uploadFile">上传文件</button> -->
        <img class="quick-icon" src="@/assets/down-ico.svg" />
        <span>文档问答</span>
      </div>
    </div>
  </div>

</template>

<style scoped>
.down-cro {
  /* height: 0.34rem; */
  width: 100%;
}

.my-information-btn {
  overflow: hidden;
  padding: 8px 0;
  -ms-flex-align: center;
  align-items: center;
  display: flex;
  overflow-x: scroll;
  width: 100%;
  box-sizing: border-box;
}

.quickItem:last-child {
  margin-right: 0;
}

.quickItem {
  /* width: 1rem;  */
  height: 100%;
  border-radius: 162px;
  opacity: 1;
  background: #ffffff;
  /* font-weight: 300; */
  line-height: 30px;
  /* flex: 3; */
  text-align: center;
  margin-right: 8px;
  display: flex;
  padding: 0 10px;
  cursor: pointer;
  color: #4A4E72;
  /* min-width: 1.04rem; */
  white-space: nowrap;
  align-items: center;
  background: rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  border: 1px solid rgba(4, 10, 57, 0.1);
  gap: 4px;
}

.quickItem img {
  width: 14px;
}
</style>
